import { render, staticRenderFns } from "./viewRequestAdmin.vue?vue&type=template&id=28456d40&scoped=true"
import script from "./viewRequestAdmin.vue?vue&type=script&lang=js"
export * from "./viewRequestAdmin.vue?vue&type=script&lang=js"
import style0 from "./viewRequestAdmin.vue?vue&type=style&index=0&id=28456d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28456d40",
  null
  
)

export default component.exports